import axios from "axios";
import dayjs from "dayjs";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { LoginContext } from "./LoginContextCopy";

// export const icURL = "http://192.168.10.151:9292"; // 혜선 서버
export const icURL = "";

export class IncheonItem {
  constructor() {
    this.id = "";
    this.name = "";
    this.sensorNames = [];
  }
}

// 보안헤더 인터셉터 설정
axios.interceptors.request.use(
  (config) => {
    config.headers["Content-Security-Policy"] = "frame-ancestors 'none'";
    config.headers["X-Content-Type-Options"] = "nosniff";
    config.headers["X-Frame-Options"] = "DENY";
    config.headers["X-Xss-Protection"] = "1; mode=block";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const DataContextCopy = createContext({});
export const DataProvider = ({ children }) => {
  const {
    loginRegionIds,
    logout,
    loginValue,
    setIsLoginState,
    login,
    isLoginState,
    userRole,
  } = useContext(LoginContext);
  const [isLoading, setIsLoding] = useState(false);
  const navigate = useNavigate();
  // 최신 데이터 조회
  const [sensorNames, setSensorNames] = useState({});
  const [sensorUnits, setSensorUnits] = useState({});
  const [lastData, setLastData] = useState([]);
  const [lastIdx, setLastIdx] = useState(1);
  const [clickedItem, setClickedItem] = useState(""); //선택한 item
  const [nodeId, setNodeId] = useState(1); //측정소명 별 id(node_id)
  const [incheonItems, setIncheonItems] = useState([]);
  const [clickedIdx, setClickedIdx] = useState(1);

  const [selectedRegionIds, setSelectedRegionIds] = useState(loginRegionIds);

  // ascon 최신값 데이터
  const [asconLastData, setAsconLastData] = useState([]);
  const [asconClickedItem, setAsconClickedItem] = useState(""); //선택한 item
  const getAsconLastData = async () => {
    try {
      await axios
        .get(`${icURL}/api/ascon/report/last`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("login"),
          },
        })
        .then((res) => {
          const resData = res.data.data;

          // resData의 모든 항목에 대해 sensor_name이 '풍향'인 값을 찾아 value를 wind_dir로 변경
          const updatedData = resData.map((item) => {
            // sensor_name 배열에서 '풍향'의 인덱스 찾기
            const windDirIndex = item.sensor_name.indexOf("풍향");

            if (windDirIndex !== -1) {
              // 해당 인덱스의 value 값을 wind_dir 값으로 변경
              item.value[windDirIndex] = item.wind_dir;
            }

            return item;
          });
          setAsconLastData(updatedData);
          console.log("asconlast : ", updatedData);
          if (res.data.data.length > 0) setAsconClickedItem(updatedData[0]);
        });
    } catch (err) {
      console.error(err);
    }
  };

  // ascon 시간별 데이터
  const [asconHourData, setAsconHourData] = useState([]);

  const getAsconHourData = async () => {
    try {
      const response = await axios.get(`${icURL}/api/ascon/report/hour`, {
        params: {
          sdate: dayjs().subtract(1, "d").format("YYYY-MM-DD 00:00"),
          edate: dayjs().format("YYYY-MM-DD HH:mm"),
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("login"),
        },
      });
      setAsconHourData(response.data.data);
      console.log("asconhour : ", response.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  //인천시 구 경계
  const [sigList, setSigList] = useState(null);
  const getIcSigList = async () => {
    try {
      await axios
        .get(`${icURL}/mobile/sig/list`, {
          params: {
            region_id: selectedRegionIds,
          },
        })
        .then((res) => setSigList(res.data.data));
    } catch (err) {
      console.error(err);
    }
  };

  // 시 경계
  const [icOutBound, setIcOutBound] = useState(null);
  const getIcOutBound = () => {
    axios.get(`${icURL}/mobile/sig/outBound`).then((res) => {
      // axios.get(`dummy/OutBound.json`).then((res) => {
      setIcOutBound(res.data.data);
    });
  };

  // 예보
  const [forecast, setForecast] = useState({});
  const forecastCodes = ["PM25", "PM10", "O3"]; // 예보 코드에 대한 배열
  const [todayData, setTodayData] = useState({});
  const [tomorrowData, setTomorrowData] = useState({});

  const getForecastData = () => {
    const forecastUrls = forecastCodes.map(
      (code) => `${icURL}/mobile/dust/forecast?code=${code}`,
    );

    const fetchRequests = forecastUrls.map((url) => axios.get(url));

    Promise.all(fetchRequests)
      .then((responses) => {
        const formattedForecasts = responses.map(
          (response) => response.data.data,
        );

        const forecastResult = formattedForecasts.reduce(
          (acc, formattedForecast, index) => {
            const informCode = forecastCodes[index];
            // 최신 데이터 기준으로 정렬
            const sortedForecast = formattedForecast.sort((a, b) =>
              dayjs(b.dataTime, "YYYY-MM-DD HH시 발표").diff(
                dayjs(a.dataTime, "YYYY-MM-DD HH시 발표"),
              ),
            );
            acc[informCode] = sortedForecast;
            return acc;
          },
          {},
        );
        setForecast(forecastResult);
        const today = dayjs().format("YYYY-MM-DD");
        const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");

        const todayDataResult = {};
        const tomorrowDataResult = {};

        forecastCodes.forEach((code) => {
          const todayForecasts = forecastResult[code]?.filter(
            (item) => item.informData === today,
          );
          const tomorrowForecasts = forecastResult[code]?.filter(
            (item) => item.informData === tomorrow,
          );

          // 가장 최근 데이터를 선택
          todayDataResult[code] = todayForecasts?.[0] || null;
          tomorrowDataResult[code] = tomorrowForecasts?.[0] || null;
        });

        setTodayData(todayDataResult);
        setTomorrowData(tomorrowDataResult);
      })
      .catch((error) => {
        console.error("Error fetching forecast data:", error);
      });
  };

  const prepareForecastData = (forecastResult, date) => {
    const forecastDataResult = {};
    forecastCodes.forEach((code) => {
      forecastDataResult[code] = forecastResult[code]?.find(
        (item) => item.informData === date,
      );
    });
    return forecastDataResult;
  };

  useEffect(() => {
    const today = dayjs().format("YYYY-MM-DD");
    const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");

    setTodayData(prepareForecastData(forecast, today));
    setTomorrowData(prepareForecastData(forecast, tomorrow));
  }, [forecast]);

  // base64 인코딩
  const encodeBase64 = (text) => {
    return btoa(unescape(encodeURIComponent(text)));
  };

  // 내 민원 확인하기
  const [myName, setMyName] = useState("");
  const [myCall, setMyCall] = useState("");
  const [myList, setMyList] = useState([]);
  const [userPwdCheck, setUserPwdCheck] = useState("");
  const [checkList, setCheckList] = useState({});
  const [error, setError] = useState("");

  const getOdorMyList = async () => {
    try {
      const encodedName = encodeBase64(myName);
      const encodedCall = encodeBase64(myCall);

      const response = await axios.get(`${icURL}/mobile/minwon/mylist`, {
        params: {
          name: encodedName,
          call: encodedCall,
        },
      });
      setMyList(response.data.data);
      console.log(response.data.data);
    } catch (err) {
      console.error("API 호출 중 오류 발생:", err);
      setError("데이터를 가져오는 중 오류가 발생했습니다.");
    }
  };

  useEffect(() => {
    if (myName && myCall) {
      // 상태가 업데이트된 후 호출
      getOdorMyList();
    }
  }, [myName, myCall]);

  // useEffect(() => {}, [myName, myCall]);
  //사용자 회원조회

  const UserSecretCheck = async () => {
    try {
      const encodedPwd = encodeBase64(userPwdCheck);
      const res = await axios.post(`${icURL}/mobile/minwon/view`, {
        mw_id: num,
        rpt_password: encodedPwd,
      });
      if (res.data && res.data.data) {
        const detailRes = res.data.data;
        setCheckList(detailRes);
        return detailRes;
      } else {
        console.error("No data in response");
        return null;
      }
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const [userAddress, setUserAddress] = useState(""); //주소
  const [userName, setUserName] = useState(""); //사용자이름
  const [userPhone, setUserPhone] = useState(0); //전화번호
  const [smellDate, setSmellDate] = useState(""); //악취신고날짜
  const [smellLev, setSmellLev] = useState(0); //악취강도
  const [smellType, setSmellType] = useState(""); //악취종류
  const [content, setContent] = useState(""); //비고란

  const [pwdCheck, setPwdCheck] = useState(""); //회원 패스워드 체크
  const [phoneCheck, setPhoneCheck] = useState(""); //회원전화번호

  //회원인증 -> 사용자ver. 관리자 답변 조회
  const [seqno, setSeqno] = useState(1);
  const [num, setNum] = useState(1);
  const [answerList, setAnswerList] = useState({});

  // 민원삭제
  const [declareDel, setDeclareDel] = useState({});
  const handleDelete = async () => {
    try {
      const encodedName = encodeBase64(myName);
      const encodedCall = encodeBase64(myCall);
      const encodedPwd = encodeBase64(userPwdCheck);
      const response = await axios.post(`${icURL}/mobile/minwon/delete`, {
        mw_id: num,
        rpt_nm: encodedName,
        rpt_password: encodedPwd,
        rpt_call: encodedCall,
      });
      const delRes = response.data.data;
      if (response.data.success) {
        setDeclareDel(delRes);
      } else {
        console.error("delete err:", response.data.message); // 에러 메시지 출력
      }
    } catch (err) {
      console.error(err);
      setDeclareDel({});
    }
  };

  useEffect(() => {
    // 처음 로드된 상태 체크. 처음 로드시 토큰 제거, 이후에는 토큰의 상태에 따라 로그인 상태 유지
    // sessionStorage 사용으로 세션 종료시 모두 삭제
    const isFirstLoad = sessionStorage.getItem("isFirstLoad") === null;
    // console.log(isFirstLoad);
    if (isFirstLoad) {
      sessionStorage.setItem("isFirstLoad", "false");
      localStorage.removeItem("login");
      localStorage.removeItem("refresh");
      setIsLoginState(false);
    } else {
      const access_token = localStorage.getItem("login");
      const refresh_token = localStorage.getItem("refresh");

      if (
        access_token &&
        access_token !== "null" &&
        access_token !== "" &&
        refresh_token &&
        refresh_token !== "null" &&
        refresh_token !== ""
      ) {
        setIsLoginState(true);
      } else {
        setIsLoginState(false);
      }
    }
  }, []);

  useEffect(() => {
    if (!isLoginState) return;
    const fetchData = async () => {
      await getIcOutBound();
      await getIcSigList();
      await getAsconLastData();
      await getAsconHourData();
    };
    fetchData();
  }, [isLoginState]);

  useEffect(() => {
    getForecastData();
  }, []);

  return (
    <DataContextCopy.Provider
      value={{
        isLoading,
        setIsLoding,
        selectedRegionIds,

        nodeId,
        setNodeId,
        incheonItems,
        setIncheonItems,

        forecast,
        setForecast,
        todayData,
        tomorrowData,

        // 민원
        UserSecretCheck,
        setNum,
        userPwdCheck,
        setUserPwdCheck,
        checkList,
        setCheckList,

        // GetEditId,
        pwdCheck,
        setPwdCheck,
        phoneCheck,
        setPhoneCheck,

        // 비번&휴대폰번호 인증-> 인증된데이터표출
        seqno,
        setSeqno,

        userAddress,
        setUserAddress,
        userName,
        setUserName,
        userPhone,
        setUserPhone,
        smellDate,
        setSmellDate,
        smellLev,
        setSmellLev,
        smellType,
        setSmellType,
        content,
        setContent,

        // 사용자 민원 삭제
        handleDelete,
        declareDel,
        setDeclareDel,

        icOutBound,
        setIcOutBound,
        asconHourData,
        setAsconHourData,
        asconLastData,
        setAsconLastData,
        asconClickedItem,
        setAsconClickedItem,

        // 내 민원 확인하기
        myName,
        setMyName,
        myCall,
        setMyCall,

        myList,
        error,
        setError,
        encodeBase64,

        clickedItem,
        setClickedItem,
      }}
    >
      {children}
    </DataContextCopy.Provider>
  );
};

export default DataContextCopy;
